export default "__VITE_ASSET__6ef3f0e8__"